// hooks/useGetTypesTickets.js
import { useEffect, useState } from "react";
import { getTypesTicket } from "../lib/ticket.js";

/**
 * Charge au montage les types de ticket sous forme de map `{ idType: libelle }` et expose `{ typesTicket, loading, error }`.
 *
 * @returns {{ typesTicket: Object.<number, string>, loading: boolean, error: string|null }}
 */
export function useGetTypesTicket() {
  const [typesTicket, setTypesTicket] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTypesTicket = async () => {
      try {
        setLoading(true);
        setError(null);

        const typeTicketData = await getTypesTicket();
        const typesMap = {};

        typeTicketData.forEach((type) => {
          typesMap[type.idType] = type.libelle;
        });

        setTypesTicket(typesMap);
      } catch (err) {
        console.error("Error fetching types ticket:", err.message);
        setError("Erreur lors de la récupération des types de ticket");
      } finally {
        setLoading(false);
      }
    };

    fetchTypesTicket();
  }, []);

  return { typesTicket, loading, error };
}
